import { Toast } from "antd-mobile";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { _ForgotPasswordOtpRequest } from "../../models/login";
import { formToObject, MOB_ICONS } from "../../utils";
import Header from "../header";
import { TextField } from "@mui/material";

const V2ForgotPassword = (props) => {
  const context = useContext(PsContext);
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [userApi, setUserApi] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    const formObject = formToObject(form);
    if (formObject.mobile.length != 10) {
      Toast.show({
        content: "Enter 10 digit mobile number",
      });
      return;
    }
    context.setLoader(true);
    _ForgotPasswordOtpRequest(formObject).then((res) => {
      if (res.status == "1") {
        setUserApi(res.data);
      } else {
        Toast.show({
          content: res.message || "Unknown Error",
        });
      }
      context.setLoader(false);
    });
  };

  if (userApi) {
    return <Navigate to={`/staff/forgot-pass-otp?${userApi}`} />;
  }

  return (
    <>
      <Header title="Forgot Password " rightActions={[]} backAction={[]} />
      <div className="my-5"></div>
      <div className="container-sm">
        <div data-aos="zoom-in">
          <div>
            <Form
              action=""
              method="post"
              noValidate
              validated={validated}
              onSubmit={handleFormSubmit}
            >
              <div className="login-img d-flex justify-content-center align-content-center">
                <img
                  className="ms-3"
                  src={MOB_ICONS.SCREEN_LOCK_256}
                  style={{ width: "100%", maxWidth: "120px" }}
                />
              </div>

              <div className="login mt-4 my-2">
                <h2 className="fw-bold text-center">Mobile Number Here</h2>

                <p className="text-center mb-4 mt-2">
                  Enter the mobile number associated with your profile.
                </p>
              </div>

              <Row>
                <Col md={12}>
                  <TextField
                    id="outlined-basic"
                    type="number"
                    className="fw-bold bg-white"
                    name="mobile"
                    label="Enter Mobile Number"
                    autoComplete={"off"}
                    autoFocus={true}
                    required
                    fullWidth
                    variant="outlined"
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={12}>
                  <Button
                    type="submit"
                    className="w-100 bg-theme"
                    variant="danger"
                    size="lg"
                  >
                    Recover Password
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
export default V2ForgotPassword;
